import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-prescripteur',
	templateUrl: './detail-prescripteur.component.html',
	styleUrls: ['./detail-prescripteur.component.scss']
})
export class DetailPrescripteurComponent implements OnInit {
	prescripteur: Prescripteur;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences;
	isPlanificatrice: boolean;
	isDeletable = true;

	labelPrescripteurCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	/**
	 * Index de pagination de la liste des formations d'un prescripteur
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	pairMissionRqEmployee: {
		missionRequest: MissionRequest;
		employeeName: string;
	}[] = [];

	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		nomStructure: new FormControl('', [
			Validators.required,
		]),
		addressStructure: new FormControl(new Address().label, [
			//Validators.maxLength(60)
		]),
		typeStructure: new FormControl(),
		contacts: this.fb.array([this.fb.group({
			id: '',
			lastName: '',
			firstName: '',
			telephoneFixe: '',
			telephonePortable: '',
			telephoneStandard: '',
			email: '',
			fonction: '',
		})])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private logger: LogService,
		private fb: FormBuilder
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'prescripteur grâce à son id
		 */
		this.facade.prescripteurService.getPrescripteurById(id).subscribe({
			next: (prescripteur: Prescripteur) => {
				this.prescripteur = prescripteur;
				if (this.prescripteur.addressStructure && this.prescripteur.addressStructure.label) {
					this.isAddressDefault.value = true;
				}
				this.facade.employeeService
					.getAllActiveEmployees()
					.subscribe((data) => {
						this.listEmployee = data;
					});
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/prescripteurs/list']);
	}

	goEdit(prescripteur: Prescripteur): void {
		const link = ['/prescripteurs/edit', prescripteur.id];
		this.router.navigate(link);
	}

	delete(prescripteur: Prescripteur): void {
		if (this.isDeletable) {
			this.facade.prescripteurService
				.deletePrescripteur(prescripteur.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();

		if (
			this.prescripteur.addressStructure &&
			this.prescripteur.addressStructure.label &&
			this.prescripteur.addressStructure.latitude &&
			this.prescripteur.addressStructure.longitude
		) {
			this.isAddressDefault.value = true;
		}
		this.isAddressSelected.value = false;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.facade.prescripteurService
				.updatePrescripteur(this.prescripteur)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
}
